// 前端积分价目 —— 纯展示,不参与任何计费逻辑/请求。
// 数字须与后端 resguard/accounts.py 的 COSTS 保持一致(只读抄数字,改价请先改后端再来对齐这里)。
export const COSTS = {
  checkup: 100,
  scan: 50,
  cross_ref: 50,
  compare: 20,
  copy_move: 20,
  dedup: 20,
  data_check: 20,
  stats_check: 10,
  stats_copilot: 20,
  interpret_stats: 10,
  interpret_image: 10,
  checkup_ask: 10,
  interpret_text: 10,
  rebuttal_split: 10,
  narrative_report: 50,
  lit_brief: 10,
  // 投稿助手三项:后端 COSTS 早已有,前端此前漏抄,导致 /guide 无法从常量渲染其价格。
  journal_match: 10,
  ref_check: 20,
  cover_letter: 20,
} as const;

export type CostKind = keyof typeof COSTS;

/** LLM 类计费项:实际扣费 = 基础价 × AI 深度档位倍率(见 lib/aiDepth.ts)。
 * 权威名单由后端 GET /api/credits 的 llm_kinds 下发,这里是同义的前端兜底常量。 */
export const LLM_COST_KINDS: readonly CostKind[] = [
  "interpret_stats",
  "interpret_image",
  "checkup_ask",
  "interpret_text",
  "rebuttal_split",
  "narrative_report",
  "lit_brief",
  // 与后端 ai_depth.LLM_KINDS 对齐:这两项同样受深度档倍率影响,此前前端兜底名单漏列。
  "journal_match",
  "cover_letter",
] as const;

export function isLlmCostKind(kind: CostKind, llmKinds?: string[] | null): boolean {
  return (llmKinds && llmKinds.length ? llmKinds : (LLM_COST_KINDS as readonly string[])).includes(kind);
}
